import http from './http';
import {
	IGoogleIntegrationCustomers,
	IGoogleIntegrationToken,
	IIntegration,
	IIntegrationItem,
} from 'src/lib/schemas';

const apiVersion = 'v1';
const integrationsUrl = `/${apiVersion}/integrations`;

const getAccountIntegrations = async (
	accountId: string,
): Promise<IIntegration> => {
	const { data } = await http.get(`${integrationsUrl}/${accountId}`);
	return data;
};

const saveSelectedPages = async (
	accountId: string,
	item: IIntegrationItem,
): Promise<IIntegration> => {
	const { data } = await http.patch(
		`${integrationsUrl}/${accountId}/facebook`,
		item,
	);
	return data;
};

const getFacebookToken = async (code: string) => {
	const { data } = await http.get('/v2/campaign/facebook/get-token', {
		params: { code },
	});
	return data;
};

const getFacebookPages = async (accessToken: string) => {
	const { data } = await http.get(
		`${integrationsUrl}/facebook/accounts?access_token=${accessToken}`,
	);
	return data;
};

const getInstagramPages = async (accessToken: string) => {
	const { data } = await http.get(
		`${integrationsUrl}/facebook/instagram-pages?access_token=${accessToken}`,
	);
	return data;
};

const getFacebookAdAccounts = async (accessToken: string) => {
	const { data } = await http.get(
		`${integrationsUrl}/facebook/ad-accounts?access_token=${accessToken}`,
	);
	const filteredAccounts = data.data.filter(
		(account: any) => account.account_status === 1,
	);
	return { data: filteredAccounts };
};

const getFacebookUserPages = async (accessToken: string) => {
	const { data } = await http.get(
		`${integrationsUrl}/facebook/user-profile?access_token=${accessToken}`,
	);
	return data;
};

const disconnectFacebook = async (accountId: string) => {
	const { data } = await http.patch(
		`${integrationsUrl}/${accountId}/facebook`,
		{ enabled: false },
	);
	return data;
};

const disconnectGoogleAds = async (accountId: string) => {
	const { data } = await http.patch(`${integrationsUrl}/${accountId}/google`, {
		enabled: false,
	});
	return data;
};

const getGoogleCustomers = async (
	accountId: string,
): Promise<IGoogleIntegrationCustomers[]> => {
	try {
		const { data } = await http.get(
			`${integrationsUrl}/${accountId}/google-customers`,
		);
		return data.results;
	} catch (error: any) {
		if (
			error.response &&
			error.response.data &&
			error.response.data.error_code
		) {
			const code = error.response.data.error_code;
			const msg = error.response.data.message;

			const customError = new Error(msg);
			(customError as any).code = code;

			throw customError;
		}
		throw new Error(
			'Unknown error occurred while fetching Google Adwords customers.',
		);
	}
};

const saveSelectedGoogleAccounts = async (
	accountId: string,
	selectedAccounts: IGoogleIntegrationCustomers[],
	tokens: IGoogleIntegrationToken,
): Promise<Partial<IIntegration['social']>> => {
	const { data } = await http.patch(`${integrationsUrl}/${accountId}/google`, {
		enabled: true,
		attributes: {
			customers: selectedAccounts,
			tokens,
		},
	});
	return data;
};

export {
	getAccountIntegrations,
	saveSelectedPages,
	getFacebookToken,
	getFacebookPages,
	getFacebookUserPages,
	getFacebookAdAccounts,
	disconnectFacebook,
	disconnectGoogleAds,
	getInstagramPages,
	getGoogleCustomers,
	saveSelectedGoogleAccounts,
};
